import { Component, OnInit, ViewChild } from "@angular/core";
import { UiStateService } from "../core/services/ui-state-service";
import { Router, ActivatedRoute } from "@angular/router";
import { DorpelComponent } from "../dorpel/dorpel.component";
import { DataStateService } from "../core/services/data-state.service";
import { NeutenComponent } from "../neuten/neuten.component";
import { SluitpotComponent } from "../sluitpot/sluitpot.component";
import { BewerkingenHorizComponent } from "../bewerkingen-horiz/bewerkingen-horiz.component";
import { ModelFactory } from "../shared/models/model-factory";
import { BestellingDorpelDto } from "../shared/api-models/models";
import { environment } from "../../environments/environment";
import { filter, map, takeUntil } from "rxjs/operators";
import { BaseComponent } from "../shared/base.component";
import { Observable } from "rxjs";
import { FormGroup, FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogComponent } from "../shared/components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-overzicht",
  templateUrl: "./dorpel-page-horiz.component.html",
  styleUrls: ["./dorpel-page.component.scss"],
})
export class DorpelPageComponent extends BaseComponent implements OnInit {
  @ViewChild("acc", { static: true }) acc;
  public currentDorpel: BestellingDorpelDto;
  public viewMode: "Edit" | "Add";
  public addToCartButtonLabel: string = null;
  public addToCartAndClearButtonLabel: string = null;
  public formGroup: FormGroup;
  public invalidComponentsMessage: string | null = null;

  @ViewChild("dorpel") private dorpelForm: DorpelComponent;
  @ViewChild("neuten") private neutenForm: NeutenComponent;
  @ViewChild("sluitpotten") private sluitpotForm: SluitpotComponent;
  @ViewChild("bewerkingen") private bewerkingen: BewerkingenHorizComponent;
  private dorpelGuid: string;
  private isCurrentDoorSliding: boolean; //PRODUCTION-PATCH: remove this once HS up to par
  public showBewerkingen: boolean = true;
  private defaultSerializedDorpelData: string | null = null;

  constructor(
    private dataState: DataStateService,
    private uiStateService: UiStateService, //PRODUCTION-PATCH: remove this once HS up to par
    private uiState: UiStateService,
    private router: Router,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal
  ) {
    super();
  }

  ngOnInit(): void {
    this.dorpelGuid =
      this.activatedRoute.snapshot.queryParamMap.get("dorpelGuid");
    const productType =
      this.activatedRoute.snapshot.paramMap.get("productType");
    this.uiState.setProductType(productType); //notify header on refresh

    this.currentDorpel = !!this.dorpelGuid
      ? this.dataState.getDorpelById(this.dorpelGuid)
      : ModelFactory.createBestellingDorpel(productType);

    /**
     * serialize a version of the default dorpel configuration considered as the 'blank' state
     * save this for later use it in determining the form's pristine state in case business logic changes
     * and we need a more complex change detection. 
     * 
     * in the current version since all the fields are disabled we can know for sure that the form was touched
     * by checking if the dorpelCode field has a value set (meaning user chose a dorpel type and the rest of the fields were enabled)
     */
    // if (!this.dorpelGuid) { 
    //   //
    //   this.defaultSerializedDorpelData = JSON.stringify(this.currentDorpel);
    // }

    if (!this.currentDorpel) {
      /**
       * if we do a refresh in the edit dorpel component, we should navigate to root
       * as all the models are empty even if the dorpel guid is conserved in the path.
       * there will be no order and no model attached to the guid
       */
      this.router.navigate(["/"]);
    }

    this.formGroup = this.buildForm(this.currentDorpel);
    this.uiState.viewMode = !!this.dorpelGuid ? "Edit" : "Add";
    this.viewMode = this.uiState.viewMode;
    this.addToCartButtonLabel =
      this.viewMode === "Add"
        ? "Toevoegen aan dorpeloverzicht"
        : "Wijzigingen opslaan";
    this.addToCartAndClearButtonLabel =
      this.viewMode === "Add"
        ? "Opslaan en nieuwe dorpel maken"
        : "Wijzigingen opslaan en nieuwe dorpel toevoegen";
    this.uiState.setCurrentDorpel(this.currentDorpel);
    this.uiState.neutenCount$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((count) => {
        if (!count) {
          this.showBewerkingen = false;
          return;
        } else {
          this.showBewerkingen = true;
        }
      });
    this.uiState.dorpelCode$
      .pipe(
        filter((dorpelCode) => !!dorpelCode),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((dorpelCode) => {
        this.enableDorpelOpmerkingField();

        //PRODUCTION-PATCH: remove this once HS up to par
        const chosenDorpel = this.uiStateService.dorpelChoices.find(
          (d) => d.dorpelCode === dorpelCode
        );
        this.isCurrentDoorSliding = chosenDorpel.dorpelsoort === "Hefschuifdorpel";
        //END
      });
  }

  get isFromPrefilledOrder(): boolean {
    return !!this.uiState?.fromPrefilledOrder;
  }

  get isDorpelConfigurationDisabled(): boolean {
    // return this.isCurrentDoorSliding;
    return false;
  }

  private openConfirmationDialog() {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true
    });

    modalRef.componentInstance.title = 'Bevestiging';
    modalRef.componentInstance.message = 'U gaat terug naar de hoofdpagina al uw werk wordt niet opgeslagen wilt u doorgaan?';
    modalRef.componentInstance.confirmText = 'Ja';
    modalRef.componentInstance.cancelText = 'Nee';

    modalRef.result.then(
      (result) => {
        if (result === 'confirm') {
          this.router.navigate([this.dataState.homePath]);
        }
      },
      (reason) => { }
    );
  }

  abortCurrentConfiguration() {
    // let hasAnyDataFilled = JSON.stringify(this.currentDorpel) !== this.defaultSerializedDorpelData;
    let hasAnyDataFilled = !!this.currentDorpel.dorpelCode;
    if (hasAnyDataFilled) {
      this.openConfirmationDialog();
    } else {
      this.router.navigate([this.dataState.homePath]);
    }
  }

  private checkFormValidity(): boolean {
    let valid: boolean = true;

    const dorpel = this.dataState.createTempDorpel(this.currentDorpel);

    this.dataState
      .addDorpelData(this.dorpelForm.formGroup.value, dorpel)
      .addNeutenData(this.neutenForm.getNeutenFormData(), dorpel)
      .addSluitpottenData(this.sluitpotForm.getSluitpotModels(), dorpel)
      .addBewerkingen(this.bewerkingen?.getData() || [], dorpel);

    valid = valid && this.dorpelForm.validateZaagmaat(dorpel);

    return valid;
  }

  public addToCart(preventNavigation = false): void {
    const formsValidity = [this.dorpelForm.dataIsValid()];

    formsValidity.push(this.neutenForm.dataIsValid());
    formsValidity.push(this.sluitpotForm.dataIsValid());

    if (formsValidity.some((v) => !v) && !environment.disableFieldValidation) {
      return;
    }

    if (!this.checkFormValidity() && !environment.disableFieldValidation) {
      return;
    }

    if (!this.neutenForm.validateNeutenComponents()) {
      this.invalidComponentsMessage =
        "The current configuration has invalid components";
      return;
    } else {
      this.invalidComponentsMessage = null;
    }

    const state = !!this.dorpelGuid
      ? this.dataState.editDorpel(this.dorpelGuid)
      : this.dataState.createDorpel(this.currentDorpel);

    state
      .addDorpelData(this.dorpelForm.formGroup.value)
      .addNeutenData(this.neutenForm.getNeutenFormData())
      .addSluitpottenData(this.sluitpotForm.sluitpottenModels)
      .addBewerkingen(this.bewerkingen?.getData() || [])
      .addDorpelOpmerking(this.formGroup.get("dorpelOpmerking").value);

    state.addDrawing(this.dorpelForm.getDorpelDrawingData());

    // console.log('current state: ');
    // console.log(this.dataState.getModel());

    if (!preventNavigation) {
      this.router.navigate([this.dataState.homePath]);
    }
  }

  showSluitpottenComponent$(): Observable<boolean> {
    return this.uiState.schema$.pipe(map((s) => !s || s === ""));
  }

  public checkOtherFormsValidity(): boolean {
    return this.neutenForm.dataIsValid();
  }

  private buildForm(dorpel: BestellingDorpelDto): FormGroup {
    const formGroup = this.formBuilder.group({
      dorpelOpmerking: [{ value: dorpel?.opmerking || "", disabled: true }],
    });

    return formGroup;
  }

  private enableDorpelOpmerkingField(): void {
    this.formGroup.controls["dorpelOpmerking"].enable();
  }

  public clearData(): void {
    const currentRoute = this.activatedRoute.snapshot.url.map(segment => segment.path).join('/');
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate(["order-form", this.uiStateService.currentProductType, currentRoute]);
    });
  }

  public addToCardAndClearData(): void {
    this.addToCart(true);
    this.clearData();
  }
}
